<img [ngClass]="{ animate: animate }" src="{{ imageUrl }}" alt="" />
